import React from "react";

const Privacy = () => {
  return (
    <>
      <main className="mt-24 max-w-4xl mx-auto px-6 md:px-10 py-10 text-gray-800 leading-relaxed">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-medium text-[#1f2937] mb-2">
            Privacy Policy for Cura AI
          </h1>
          <p className="text-sm text-gray-500">Effective Date: 3rd March 2025</p>
        </div>

        <p className="mb-6">
          At Cura AI, your privacy is our priority. This Privacy Policy outlines how we collect,
          use, disclose, and protect your personal and health information in compliance with the
          Personal Information Protection and Electronic Documents Act (PIPEDA) and the Personal
          Health Information Protection Act (PHIPA).
        </p>

        <div className="space-y-6 text-[1.05rem]">
          <div>
            <h2 className="font-semibold text-lg mb-1">1. Accountability</h2>
            <p>
              Cura AI has appointed a Privacy Officer responsible for ensuring our compliance with
              applicable privacy laws. You can reach our Privacy Officer at{" "}
              <a href="mailto:privacy@curaai.ca" className="text-blue-600 hover:underline">
                privacy@curaai.ca
              </a>.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">2. Identifying Purposes</h2>
            <ul className="list-disc pl-6">
              <li>Scheduling and managing patient appointments.</li>
              <li>Supporting patient intake and clinical triage processes.</li>
              <li>Facilitating communication between patients and healthcare providers.</li>
              <li>Enhancing our services using anonymized and aggregated data analytics.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">3. Consent</h2>
            <p>
              We obtain your explicit consent before collecting, using, or disclosing your
              information. Consent may be obtained electronically, verbally during a call, or
              through written agreement.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">4. Limiting Collection</h2>
            <p>
              We only collect the minimum amount of personal and health information required to
              fulfill the purposes stated above on behalf of partner clinics.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">5. Limiting Use, Disclosure, and Retention</h2>
            <p>
              Your information will be used and disclosed only for the purposes for which it was
              collected. We retain data only as long as necessary to meet legal and operational
              requirements as advised by the partner clinics, after which it is securely deleted or
              anonymized.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">6. Accuracy</h2>
            <p>
              We take reasonable steps to ensure that the information we collect is accurate and up
              to date. You can request to update your personal information at any time.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">7. Safeguards</h2>
            <p>
              We implement administrative, technical, and physical safeguards to protect your
              personal data, including encryption, access controls, audit logging, and secure
              storage.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">8. Openness</h2>
            <p>
              Our privacy practices are transparent. This policy is publicly available, and we are
              happy to answer any questions you may have about how we handle your information.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">9. Individual Access</h2>
            <p>
              You have the right to access your personal information held by Cura AI and request
              corrections if necessary. Contact us at{" "}
              <a href="mailto:info@curaai.ca" className="text-blue-600 hover:underline">
                info@curaai.ca
              </a>{" "}
              to make a request.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">10. Challenging Compliance</h2>
            <p>
              If you have concerns or complaints about our privacy practices, you may contact our
              Privacy Officer. All inquiries will be addressed promptly and in accordance with
              applicable laws.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">Contact Us</h2>
            <p>
              <strong>Privacy Officer – Cura AI</strong>
              <br />
              Email:{" "}
              <a href="mailto:privacy@curaai.ca" className="text-blue-600 hover:underline">
                privacy@curaai.ca
              </a>
            </p>
          </div>

          <p className="italic text-gray-500 text-sm pt-6">
            We may update this Privacy Policy from time to time. Any changes will be communicated
            through our website or application.
          </p>
        </div>
      </main>
    </>
  );
};

export default Privacy;
